import { render, staticRenderFns } from "./GiftSubscriptionModal.vue?vue&type=template&id=c4bec2c2&scoped=true"
import script from "./GiftSubscriptionModal.vue?vue&type=script&lang=js"
export * from "./GiftSubscriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bec2c2",
  null
  
)

export default component.exports